/** @public @react */
export function DefaultBackground() {
	return <div className="tl-background" />
}
